/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UpdateOrgQuotaAuthOrgsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class UpdateOrgQuotaAuthOrgsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaAuthOrgsResponse429ResponseBodyData;

  constructor(
    err: UpdateOrgQuotaAuthOrgsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaAuthOrgsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UpdateOrgQuotaAuthOrgsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class UpdateOrgQuotaAuthOrgsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaAuthOrgsResponse409ResponseBodyData;

  constructor(
    err: UpdateOrgQuotaAuthOrgsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaAuthOrgsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UpdateOrgQuotaAuthOrgsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class UpdateOrgQuotaAuthOrgsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaAuthOrgsResponse404ResponseBodyData;

  constructor(
    err: UpdateOrgQuotaAuthOrgsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaAuthOrgsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UpdateOrgQuotaAuthOrgsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class UpdateOrgQuotaAuthOrgsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaAuthOrgsResponseResponseBodyData;

  constructor(
    err: UpdateOrgQuotaAuthOrgsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaAuthOrgsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UpdateOrgQuotaAuthOrgsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UpdateOrgQuotaAuthOrgsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaAuthOrgsResponseBodyData;

  constructor(
    err: UpdateOrgQuotaAuthOrgsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaAuthOrgsResponseBody";
  }
}

/**
 * Bad request
 */
export type UpdateOrgQuotaResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UpdateOrgQuotaResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgQuotaResponseBodyData;

  constructor(
    err: UpdateOrgQuotaResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgQuotaResponseBody";
  }
}

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgQuotaAuthOrgsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgQuotaAuthOrgsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgQuotaAuthOrgsResponse429ResponseBody
  > = z.instanceof(UpdateOrgQuotaAuthOrgsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgQuotaAuthOrgsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgQuotaAuthOrgsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgQuotaAuthOrgsResponse409ResponseBody
  > = z.instanceof(UpdateOrgQuotaAuthOrgsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgQuotaAuthOrgsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgQuotaAuthOrgsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgQuotaAuthOrgsResponse404ResponseBody
  > = z.instanceof(UpdateOrgQuotaAuthOrgsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponseResponseBody$inboundSchema:
  z.ZodType<UpdateOrgQuotaAuthOrgsResponseResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new UpdateOrgQuotaAuthOrgsResponseResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type UpdateOrgQuotaAuthOrgsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponseResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgQuotaAuthOrgsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgQuotaAuthOrgsResponseResponseBody
  > = z.instanceof(UpdateOrgQuotaAuthOrgsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponseBody$inboundSchema: z.ZodType<
  UpdateOrgQuotaAuthOrgsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateOrgQuotaAuthOrgsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateOrgQuotaAuthOrgsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaAuthOrgsResponseBody$outboundSchema: z.ZodType<
  UpdateOrgQuotaAuthOrgsResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgQuotaAuthOrgsResponseBody
> = z.instanceof(UpdateOrgQuotaAuthOrgsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const UpdateOrgQuotaResponseBody$inboundSchema: z.ZodType<
  UpdateOrgQuotaResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateOrgQuotaResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateOrgQuotaResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgQuotaResponseBody$outboundSchema: z.ZodType<
  UpdateOrgQuotaResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgQuotaResponseBody
> = z.instanceof(UpdateOrgQuotaResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
